<div *ngIf="visible" class="d-flex gap-3 align-items-center mt-2 alert alert-danger">
  <i class="fas fa-times-circle"></i>
  <span>
    {{errorMessage}}
  </span>
</div>
